import { render, staticRenderFns } from "./DashboardLeaderboards.vue?vue&type=template&id=78d275ff&scoped=true&"
import script from "./DashboardLeaderboards.vue?vue&type=script&lang=js&"
export * from "./DashboardLeaderboards.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLeaderboards.vue?vue&type=style&index=0&id=78d275ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d275ff",
  null
  
)

export default component.exports